import { Box, Button, Flex, Table, Tbody, Td, Text, Th, Thead, Tr, useToast } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useGetTotalEmissions } from "../../../../../hooks/query/emissions-insight/emissions-insights-query";
import { ArrowLeft } from "@phosphor-icons/react";
import { ScopeCard } from "../SummaryCards";
import * as React from "react";
import { getFormattedNumValue } from "../../../../../utils";
import { H2 } from "../../../../../components/text/headings";

const ScopeOneDetail = ({ currentYearData, previousYearData, isFetchingCurrentYear, isFetchingPreviousYear }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleBack = () => {
    const params = new URLSearchParams(searchParams);
    params.delete("detailView");
    setSearchParams(params);
  };

  return (
    <Flex direction="column" gap={4}>
      <Flex justifyContent="flex-start" mb={4}>
        <Button leftIcon={<ArrowLeft size={18} />} variant="plain" colorScheme="gray" onClick={handleBack}>
          Insights
        </Button>
      </Flex>

      <H2>Scope 1 - Direct Emissions</H2>

      <Flex direction="column" gap={4} mb={6} minW="350px" width="33%">
        <ScopeCard
          title="Total"
          currentYear={currentYearData?.scope1Total}
          previousYear={previousYearData?.scope1Total}
          currentLoading={isFetchingCurrentYear}
          previousLoading={isFetchingPreviousYear}
          theme="dark"
        />
      </Flex>

      <Flex p={4} gap={0} bg="gray.200" border="solid 1px" borderColor="gray.300" borderRadius="md">
        <Box flex="1" borderRight="1px solid" borderColor="limeShade.700" pr={4}>
          <ConsumptionTable title="Stationary" data={currentYearData?.scopeOneAndTwoDetail?.stationary} />
        </Box>
        <Box flex="1" pl={4}>
          <ConsumptionTable title="Mobile" data={currentYearData?.scopeOneAndTwoDetail?.mobile} />
        </Box>
      </Flex>
    </Flex>
  );
};

export const ConsumptionTable = ({ title, data }) => {
  const hasData = Array.isArray(data) && data.length > 0;

  return (
    <Box>
      <Text variant="cardTitle">{title}</Text>
      {hasData ? (
        <Table size="sm" variant="unstyled" mt={4}>
          <Thead>
            <Tr>
              <Th colSpan={2}></Th>
              <Th>Consumption</Th>
              <Th>Emissions</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="body.xs" color="gray.600">
            {data.map((item, idx) => (
              <Tr key={idx}>
                <Td colSpan={2}>
                  <Text as="span" fontWeight="bold">
                    {item.consumptionType}
                  </Text>{" "}
                  ({item.measurementUnit})
                </Td>
                <Td>{getFormattedNumValue(item.consumption, 2) || 0}</Td>
                <Td>{getFormattedNumValue(item.emissions, 2) || 0}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      ) : (
        <Text color="gray.600" mt={4} align="center">
          No data
        </Text>
      )}
    </Box>
  );
};

export default ScopeOneDetail;
